import React from 'react';
import { Upload } from 'lucide-react';

function FileUpload({ onFileSelect, file }) {
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      onFileSelect(selectedFile);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const selectedFile = event.dataTransfer.files[0];
    if (selectedFile) {
      onFileSelect(selectedFile);
    }
  };

  return (
    <div style={{ marginBottom: '32px' }}>
      <label
        htmlFor="file-upload" // Associates this label with the input below
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '650px',
          height: '128px',
          border: '2px dashed white',
          borderRadius: '8px',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <Upload size={48} color="white" />
        <span style={{ marginTop: '8px', color: 'white' }}>Select a file</span>
        <input
          type="file"
          id="file-upload" // Matches the htmlFor attribute of the label
          onChange={handleFileChange}
          style={{ display: 'none' }} // Hidden input, triggered by clicking the label
        />
      </label> 
      {!file && (
        <p style={{ marginTop: '8px', color: 'white', fontSize: '0.8rem', textAlign: 'left' }}>
          Note: Click to select or drag and drop your file here. For batch upload, please upload a zip file.
        </p>
      )}
      {file && <p style={{ marginTop: '8px', color: 'white' }}>Selected file: {file.name}</p>}
      
    </div>
  );
}

export default FileUpload;